var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoToPlansWhiteicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18.371,
    height: 18.63,
    viewBox: "0 0 18.371 18.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill-2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-3"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill-3"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Go-to-plans",
    transform: "translate(-104.729 -365.809)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "reload-outline",
    transform: "translate(122.536 381.756) rotate(172)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_397",
    "data-name": "Path 397",
    d: "M14.238,12.135l-.854.994A7.765,7.765,0,1,1,15.09,5.177",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_398",
    "data-name": "Path 398",
    d: "M2.427,2.154V.272A.272.272,0,0,0,2.154,0H.273A.272.272,0,0,0,.08.465L1.962,2.346A.272.272,0,0,0,2.427,2.154Z",
    transform: "translate(12.842 10.845)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1138",
    "data-name": "Group 1138",
    transform: "translate(109 369.89)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_377",
    "data-name": "Rectangle 377",
    width: 10,
    height: 10,
    transform: "translate(0 0.11)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1137",
    "data-name": "Group 1137",
    transform: "translate(1 0.327)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1133",
    "data-name": "Group 1133",
    transform: "translate(1.663 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_380",
    "data-name": "Rectangle 380",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill",
    width: 0.701,
    height: 1.869,
    rx: 0.351,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.5h0.7010146975517273M0.5,0v1.8693726062774658M0.7010146975517273,1.3693726062774658h-0.7010146975517273M0.2010146975517273,1.8693726062774658v-1.8693726062774658",
    fill: "none",
    clipPath: "url(#clip)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_380-2",
    "data-name": "Rectangle 380",
    transform: "translate(1.869)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-2",
    width: 0.701,
    height: 1.869,
    rx: 0.351,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.5h0.7010146975517273M0.5,0v1.8693726062774658M0.7010146975517273,1.3693726062774658h-0.7010146975517273M0.2010146975517273,1.8693726062774658v-1.8693726062774658",
    fill: "none",
    clipPath: "url(#clip-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_380-3",
    "data-name": "Rectangle 380",
    transform: "translate(3.739)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-3",
    width: 0.701,
    height: 1.869,
    rx: 0.351,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.5h0.7010146975517273M0.5,0v1.8693726062774658M0.7010146975517273,1.3693726062774658h-0.7010146975517273M0.2010146975517273,1.8693726062774658v-1.8693726062774658",
    fill: "none",
    clipPath: "url(#clip-3)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_381",
    "data-name": "Rectangle 381",
    transform: "translate(0 0.783)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 9,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 7,
    height: 8,
    rx: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1134",
    "data-name": "Group 1134",
    transform: "translate(1.663 2.804)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_382",
    "data-name": "Rectangle 382",
    width: 2.804,
    height: 0.701,
    rx: 0.351,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_383",
    "data-name": "Rectangle 383",
    width: 4.44,
    height: 0.701,
    rx: 0.351,
    transform: "translate(0 1.735)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_384",
    "data-name": "Rectangle 384",
    width: 4.44,
    height: 0.701,
    rx: 0.351,
    transform: "translate(0 3.469)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoToPlansWhiteicon);
export default __webpack_public_path__ + "static/media/go-to-plans-whiteicon.f691f227b21654f7cf5b6ca85b0a47a1.svg";
export { ForwardRef as ReactComponent };